import { render } from "./foot.vue?vue&type=template&id=4d046a77&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=4d046a77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d046a77"]])

export default __exports__